import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { ZPOT_INTEG_URI, ZPOT_PROD_URI } from 'constants/zpotHosts';

import { goToPaymentStep } from 'actions/checkout/payments';
import { fetchCheckoutData } from 'actions/checkout/purchase';
import ModalOverlay from 'components/checkout/caap/ModalOverlay';
import { onEvent, supportsPassiveEventListener } from 'helpers/EventHelpers';
import {
  closeButton as closeButtonCss,
  modalTitleContainer as modalTitleContainerCss,
  wrapper as wrapperCss
} from 'styles/components/checkout/caap/payment/newPaymentTypeModal.scss';
import css from 'styles/components/checkout/caap/payment/ccivrpayment.scss';

const containerStyle = cn(wrapperCss, css.section);

export class CCIVRPayment extends Component {
  componentDidMount() {
    const opts = supportsPassiveEventListener() ? { passive: true } : false;
    onEvent(window, 'message', this.receiveMessage, opts, this);
    this.ccivrFrameFormRef.submit();
  }

  receiveMessage = event => {
    const { fetchCheckoutData, goToPaymentStep } = this.props;
    const { origin, data } = event;

    if (![ZPOT_PROD_URI, ZPOT_INTEG_URI].includes(origin) && data !== 'resetCheckout') {
      return;
    }

    fetchCheckoutData({
      initializeAddressesAndPayments: true,
      includeShipmentOptions: true
    });

    goToPaymentStep();
  }

  render() {
    const { testId } = this.context;
    const {
      checkoutData: { purchaseData: { data: { shippingAddressId } } },
      environmentConfig,
      onCloseModalOverlayClick,
      title = 'Add a debit or credit card',
      endpoint = 'addNewCardForm'
    } = this.props;

    const host = environmentConfig.checkout?.zpotHost || ZPOT_PROD_URI;
    const action = `${host}/payment/${endpoint}`;

    return (
      <div className={containerStyle}>
        <ModalOverlay onCloseModalOverlayClick={onCloseModalOverlayClick} showAsModal={false}>
          <div className={modalTitleContainerCss}>
            { title }
            <button
              type="button"
              aria-label="Close modal"
              className={closeButtonCss}
              data-test-id={testId('closeCCIVRModal')}
              onClick={onCloseModalOverlayClick}
              onKeyPress={onCloseModalOverlayClick}
              role="link"
              tabIndex="0"
              title="Close Modal" />
          </div>
          <form
            ref={el => this.ccivrFrameFormRef = el}
            target="ccivrFrame"
            action={action}
            method="post"
            id="ccivrForm">
            <input type="hidden" name="addressId" value={shippingAddressId} />
          </form>
          <iframe
            frameBorder="0"
            name="ccivrFrame"
            title="ccivr payment" />
        </ModalOverlay>
      </div>
    );
  }
}

CCIVRPayment.contextTypes = {
  testId: PropTypes.func
};

export function mapStateToProps(state) {
  const { checkoutData, environmentConfig } = state;
  return {
    checkoutData,
    environmentConfig
  };
}

export default connect(mapStateToProps, {
  fetchCheckoutData,
  goToPaymentStep
})(CCIVRPayment);
